import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl'; // https://docs.mapbox.com/mapbox-gl-js/guides/install/#excluding-mapbox-gl-js-explicitly-from-transpilation
import 'mapbox-gl/dist/mapbox-gl.css';
import moment from 'moment';
import MapboxHelper from './mapboxHelper';
import MapboxToggleFollowSelectedRavenControl from './mapboxExtendedControls/mapboxToggleFollowSelectedRavenControl'

import ResizeThrottler from 'APP_ROOT/components/ResizeThrottler';
import BackgroundRefresher from '../common/backgroundRefresher';
import Events from '../common/events';
import RavenUtil from '../common/ravenUtil';
import { strings } from '../../localization';

/*
import GJV from 'geojson-validation';

function checkGeoJSON(data)
{

    var reportFunc = (valid, errors) => {
        if(!valid){
           console.error("GeoJSON: Errors", errors, data);
        }
    };

    if(!data)
        console.error("GeoJSON: No Data");
    if(!data.type)
        console.error("GeoJSON: No Data Type", data);
    if(data.type == "Feature")
        GJV.isFeature(data, reportFunc);
    else if(data.type == "FeatureCollection")
        GJV.isFeatureCollection(data, reportFunc);
    else
        console.error("GeoJSON: Unknown Data Type", data.type, data);
}
*/

export default class MapboxMap extends Component {

    constructor(props) {

        super(props);
        this.defaultZoom = 16;
        this.iconSize = 1.00;//0.25;
        this.allRavensLoaded = false;
        this.firstEventLayerName = undefined;
        this.firstCarLayerName = "car-cluster";
        this.selectedRavenUuid = undefined;

        this.highlightedRouteColour = "rgba(42, 174, 211, 1.0)";
        this.defaultRouteColour = 'rgba(42, 174, 211, 0.3)';
        this.highlightedEventOpacity = 1.0;
        this.defaultEventOpacity = 0.3;
        this.speedingColour = 'rgba(243, 47, 47, 1.0)';
        this.engineColour = 'rgba(92, 177, 27, 1.0)';
        this.warningColour = 'rgba(205, 163, 51, 1.0)';

        this.carSourceName = "cars";

        // The maximum number of points in a given route layer before we create a new one
        this.maxRouteLayer = 100;

        this.popupKillTimeout = null;

        this.highlightedRouteRaven = null;
        this.popupRaven = null;

        this.popups = [];
        this.ravens = {
            'list': []
        };

        this.mapLoaded = false;

        this.mapboxControlIsFollowingSelectedRaven = true;
        this.mapboxToggleFollowSelectedRavenControl = null;

        if(props.tripSharing || props.isHistoryPage)
        {
            // update default colours for trip sharing
            this.highlightedRouteColour = "rgba(42, 174, 211, 1.0)";
            this.defaultRouteColour = 'rgba(42, 174, 211, 1.0)';
            this.highlightedEventOpacity = 1.0;
            this.defaultEventOpacity = 1.0;
        }
    }

    componentDidMount() {

        this.loadMap();

        // Don't initialize here, map not loaded


        // Set the selected raven if we have one right away
        if (this.props.selectedRaven) {
            this.selectedRavenUuid = this.props.selectedRaven.ravenUuid;
        }

        // Set the initial map bounds so as to not zoom to all of north america on start

        if (this.props.ravens.length > 1) {

            this.zoomToAllRavens();

        }

    }

    componentWillReceiveProps(newProps) {

        // Check to see if we have performed the initial map load
        if (this.mapLoaded)
            this.updateFromProps(newProps);
        
    }

    componentWillUnmount() {

        if (this.map) {
            this.map.remove();
        }
        // halt animation
        this.haltAnimation = true;
    }

    //////////////////////
    //MAP INITIALIZATION//
    //////////////////////

    loadMap() {

        this.map = MapboxHelper.createMap({
            container: this.props.mapId,
            theme: this.props.theme,
            center: [-98.50, 40.0],
            zoom: this.defaultZoom,
            onLoad: this.onMapLoaded.bind(this)
        });
    }

    updateFromProps(newProps) {

        var ravenChanged = null;
        var previousSelectedRavenUuid = this.selectedRavenUuid;

        var ravensSeen = [];

        var ravenRouteCount = 0;

        var carFeatures = [];

        // Go through all the ravens passed in
        newProps.ravens.forEach((obj) => {

            // Ensure dashboard object as it has most of the state
            // It's possible for it not to exist early on before the lambda calls return
            if (!obj.dashboard)
                return;

            var pos = obj.dashboard.route ? obj.dashboard.route.last() : obj.lastLocation;
            if (!pos) {
                return;
            }

            var feature = { type: 'Feature' };

            
            var ravenUUID = obj.ravenUuid;

            var heading = 0;
            if (obj.vehicleState)
                heading = obj.vehicleState.heading;

            var vehiclename = obj.vehicle && obj.vehicle.name ? obj.vehicle.name : "";

            ravensSeen.push(ravenUUID);

            if (obj.dashboard.route && obj.dashboard.route.length > 0)
                ravenRouteCount++;

            var pnt = [pos.lon, pos.lat];

            // We haven't seen this Raven before
            if (!this.ravens[ravenUUID]) {

                this.ravens[ravenUUID] = this.createEmptyRavenObject();

                this.ravens[ravenUUID].eventLength = this.addEventsLayer(ravenUUID, vehiclename, obj.dashboard.events ? obj.dashboard.events : []);

                this.ravens[ravenUUID].routeIndex = this.addRouteLayers(ravenUUID, vehiclename, obj.dashboard.route ? obj.dashboard.route : [], heading, pnt);

                this.ravens.list.push(ravenUUID);
            }
            else {
                // We have this Raven.  Sources and layers setup
                // Update relevant sources based on differences 

                // console.log("Updating Raven", ravenUUID);

                if (obj.dashboard.events && this.ravens[ravenUUID].eventLength !== obj.dashboard.events.length) {
                    // Change the events if there is a different length
                    this.updateEventsLayer(ravenUUID, obj.dashboard.events);
                }

                this.ravens[ravenUUID].routeIndex = this.updateCarAndAnimtedRouteSource(ravenUUID, obj.lastLocation, heading, obj.dashboard.route, this.ravens[ravenUUID].routeIndex);
            }

            /* Remember the last point for following purposes*/
            this.ravens[ravenUUID].lastPosition = pnt;
            feature.geometry = { "type": "Point", "coordinates": pnt };
            feature.properties = {
                "status": obj.isDriving ? "driving" : "parked"
            }
            carFeatures.push(feature);

        });

        this.map.getSource(this.carSourceName).setData({
            type: "FeatureCollection",
            features: carFeatures
        });

        // Get the list of stale ravens
        var staleRavens = this.ravens.list.filter((elem) => {
            if (ravensSeen.indexOf(elem) < 0) {
                return true
            } else {
                return false
            }
        });

        // Remove data from stale ravens
        staleRavens.forEach((name) => {

            // Remove all associated layers from Mapbox
            this.ravens[name].layers.forEach((layer) => {
                this.map.removeLayer(layer);
            });
            // Remove all associated sources from Mapbox
            this.ravens[name].sources.forEach((src) => {
                this.map.removeSource(src);
            });

            // Remove all associated Raven data
            this.ravens[name] = undefined;
        });

        // Update Raven list to only include
        this.ravens.list = ravensSeen;

        /* If we are following the car, do so */
        if(this.mapboxControlIsFollowingSelectedRaven && this.ravens.hasOwnProperty(this.selectedRavenUuid)) // 'hasOwnProperty' check added for https://sentry.io/organizations/klashwerks/issues/2761387823/?project=1264372, also issues 2761297785, 2761272610, 2761228396, 2761198796, 2761077079
        {
            var pnt = this.ravens[this.selectedRavenUuid].lastPosition;
            this.animateCameraToPoint(pnt);
        }
        /* If the Raven changed, ensure it is in view */
        if (ravenChanged && this.ravens[ravenChanged] && !this.ravens[ravenChanged].hidden) {
            
            var features = this.map.queryRenderedFeatures({layers:[this.carSourceName]});

            if(!features.find( (feature) => {
                return (feature.properties.uuid === ravenChanged);
            })) {
                if (this.ravens.hasOwnProperty(this.selectedRavenUuid)) {
                    var pnt = this.ravens[ravenChanged].lastPosition;
                    this.animateCameraToPoint(pnt);
                }
            }
        }

    }

    createEmptyRavenObject() {

        return {
            routeIndex: 0,
            eventLength: 0,
            layerIndex: 0,
            sources: [],
            layers: []
        };
    }

    // Builds a new source and layer for a given geoJSON route.
    addRouteLayers(ravenname, vehiclename, route, heading, pnt) {

        // ADD ORIGINAL ROUTE LAYER
        var geoJsonRoute = [];

        var osourcename = ravenname + "-route-orig";
        var olayername = ravenname + "-route-orig";
        var sourcename = ravenname + "-route";
        var routelayername = ravenname + "-route";

        if (route) {
            // If we have an initial route, add it in
            geoJsonRoute = this.getGeoJsonLineForRoute(route, 0, -1);

            //route line
            var routeData;
            if(geoJsonRoute)
            {
                routeData = {
                    "type": "geojson",
                    "data": {
                        "type": "FeatureCollection",
                        "features": [
                            {
                                "type": "Feature",
                                "properties": {
                                    "type": "route"
                                },
                                "geometry": {
                                    "type": "LineString",
                                    "coordinates": geoJsonRoute,
                                    "uuid": ravenname,
                                    "name": vehiclename,
                                }
                            }
                        ]
                    }
                }
            }
            else
            {
                routeData = {
                    "type": "geojson",
                    "data": {
                        "type": "FeatureCollection",
                        "features": []
                    }
                };
            }

            // checkGeoJSON(routeData.data);

            this.addSource(osourcename, routeData);

            this.map.addLayer({
                "id": olayername,
                "type": "line",
                "source": osourcename,
                "layout": {
                    "line-join": "round",
                    "line-cap": "round"
                },
                "paint": {
                    "line-color": this.defaultRouteColour,
                    // "line-color": "#fff",
                    "line-width": 6,
                },
                filter: ["!has", "point_count"],
            }, this.firstEventLayerName);

            this.ravens[ravenname].sources.push(osourcename);
            this.ravens[ravenname].layers.push(olayername);
        }

        // ADD ANIMATING ROUTE LAYER

        this.map.addSource(sourcename, { "type": "geojson", "data": { "type": "FeatureCollection", "features": [] } } );
        this.map.addLayer({
            "id": routelayername,
            "type": "line",
            "source": sourcename,
            "layout": {
                "line-join": "round",
                "line-cap": "round"
            },
            "paint": {
                "line-color": this.defaultRouteColour,
                "line-width": 6,
            },
            filter: ["!has", "point_count"],
        }, this.firstEventLayerName);

        this.ravens[ravenname].sources.push(sourcename);
        this.ravens[ravenname].layers.push(routelayername);

        this.ravens[ravenname].carRouteSource = this.map.getSource(sourcename);

        return route.length - 1;
    }

    updateRouteLayer(ravenname, route) {

        // NOTE NOTE NOTE
        // Wholesale overwrite of original route data.  
        // You probably don't want this function
        // NOTE NOTE NOTE

        var sourcename = ravenname + "-route-orig";

        var geoJsonRoute = this.getGeoJsonLineForRoute(route, 0, -1);

        //route line
        var routeData;
        if(geoJsonRoute)
        {
            routeData = {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "type": "LineString",
                    "coordinates": geoJsonRoute
                }
            };
        }
        else
        {
            routeData = {
                "type": "FeatureCollection",
                "features": []
            };
        }

        // checkGeoJSON(routeData);

        this.map.getSource(sourcename).setData(routeData);

        return route.length - 1;
    }

    /* Splice and convert route data into geojson format between start and end */
    getGeoJsonLineForRoute(route, startIndex, endIndex) {

        // console.log("GeoJson Line for Route", route.length, startIndex, endIndex);

        var geoJsonArray = [];
        if (endIndex < 0) endIndex = route.length;
        for (var index = startIndex; index < endIndex; index++) {
            var point = route[index];
            if (point.lon && point.lat) geoJsonArray.push([point.lon, point.lat]);
        }

        if (geoJsonArray.length == 0)
            return undefined;
        if (geoJsonArray.length == 1)
            geoJsonArray.push(geoJsonArray[0]);

        // console.log("Full route", route.length, "Returning", geoJsonArray.length);

        return geoJsonArray;
    }

    mapboxRemoveToggleFollowSelectedRavenControl() {
        this.map.removeControl(this.mapboxToggleFollowSelectedRavenControl);
        this.mapboxToggleFollowSelectedRavenControl = null;
    }

    mapboxAddToggleFollowSelectedRavenControl() {
        this.mapboxToggleFollowSelectedRavenControl = new MapboxToggleFollowSelectedRavenControl(
            this.mapboxControlIsFollowingSelectedRaven,
            this.mapboxToggleFollowSelectedRavenControlCallback
        );
        this.map.addControl(this.mapboxToggleFollowSelectedRavenControl);
    }

    mapboxPanToRaven (ravenUuid) {
        if (!this.ravens.hasOwnProperty(ravenUuid)) {
            return;
        }
        var featureData = this.ravens[ravenUuid].carRouteSource && this.ravens[ravenUuid].carRouteSource._data && this.ravens[ravenUuid].carRouteSource._data.features ? this.ravens[ravenUuid].carRouteSource._data.features[1] : undefined;

        if(featureData)
        {
            var targetPoint = featureData.geometry.coordinates.last();
            this.animateCameraToPoint(targetPoint, 500);
        }
        else if(this.ravens[ravenUuid].lastPosition)
        {
            this.animateCameraToPoint(this.ravens[ravenUuid].lastPosition, 500);
        }
    }


    mapboxToggleFollowSelectedRavenControlCallback = (mapboxControlShouldFollowSelectedRaven) => {

        this.mapboxControlIsFollowingSelectedRaven = mapboxControlShouldFollowSelectedRaven;

        if (this.mapboxControlIsFollowingSelectedRaven === true) {
            this.map.removeControl(this.mapboxToggleFollowSelectedRavenControl);
        }


        var selectedRavenUuid = this.selectedRavenUuid;

        if (selectedRavenUuid) {
            this.mapboxPanToRaven(selectedRavenUuid);
        } else {
            // console.log("mapboxToggleFollowSelectedRavenControlCallback getSelectedRavenUuidFromProps returned null");
        }
    }


    onMapLoaded() {

        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));

        this.map.on('dragstart', this.onDragStart);
        this.map.on('rotate', this.onRotate);
        this.resize();

        var geolocate = new mapboxgl.GeolocateControl({
            positionOptions: {
                enableHighAccuracy: true
            },
            trackUserLocation: true
        });

        geolocate.on("trackuserlocationstart", () => { this.onDragStart() });

        // this.createGeofenceSourceAndLayer();

        this.map.addControl(geolocate);

        this.createCarSourceAndLayer();

        // Initialize from props
        this.updateFromProps(this.props);

        this.mapLoaded = true;
    }

    createCarSourceAndLayer() {

        var me = this;

        // Colours for light theme
        var textColor = '#000000';
        var textHaloColor = '#FFFFFF';

        if(this.props.theme !== 'light')
        {
            textColor = '#FFFFFF';
            textHaloColor = '#000000';
        }

        this.addSource(this.carSourceName, {
            type: "geojson",
            data: {
                type: "FeatureCollection",
                features: []
            }
        });

        this.map.addLayer({
            "id": this.firstCarLayerName, //this.carSourceName + "-basic_vehicle_marker",
            "type": "symbol",
            "source": this.carSourceName,
            "layout": {
                "icon-image": ["match",
                    ["get", "status"],

                    ["parked"],
                    "kw02_basic-parked-mode-marker",

                    "kw02_basic-driving-mode-marker" // fallback is driving marker
                ],
                "icon-size": 1.0,
                "icon-anchor": "center",
                "icon-allow-overlap": true,
                "text-allow-overlap": true
            },
            filter: ["!has", "point_count"],
        });
    }

    resize = () => {
        this.map.resize();
    }

    zoomToAllRavens() {

        var allbounds = undefined;
        this.props.ravens.forEach((obj) => {
            var bounds;
            if (obj.lastLocation) {
                var coordinates = [obj.lastLocation.lon, obj.lastLocation.lat];

                if (coordinates[0] && coordinates[1]) {
                    bounds = new mapboxgl.LngLatBounds(coordinates, coordinates);

                    if (!allbounds)
                        allbounds = bounds;
                    else
                        allbounds.extend(bounds);
                }
            }
        });

        if (allbounds)
        {
            this.zoomToExtents(allbounds, true);
        }
    }

    updateCarAndAnimtedRouteSource(ravenname, lastLocation, heading, route, startIndex) {

        // if the new route is longer than our max, create a new source/layer combo
        if ((route.length - startIndex) > (this.maxRouteLayer + 2)) {
            var idx = this.ravens[ravenname].layerIndex;
            var sourcename = ravenname + "-route" + idx;
            var routelayername = ravenname + "-route" + idx;

            this.ravens[ravenname].layerIndex = idx + 1;

            var geoJsonRoute = this.getGeoJsonLineForRoute(route, startIndex, route.length - 1);

            var geojson;
            if(geoJsonRoute)
            {
                geojson = {
                    "type": "geojson",
                    "data": {
                        "type": "FeatureCollection",
                        "features": [
                            {
                                "type": "Feature",
                                "geometry": {
                                    "type": "LineString",
                                    "coordinates": geoJsonRoute,
                                },
                                "properties": {
                                    "type": "route"
                                }
                            }
                        ]
                    }
                };
            }
            else
            {
                geojson = {
                    "type": "geojson",
                    "data": {
                        "type": "FeatureCollection",
                        "features": []
                    }
                };
            }

            this.addSource(sourcename, geojson);

            var routeColour = this.defaultRouteColour;

            if (ravenname === this.selectedRavenUuid)
                routeColour = this.highlightedRouteColour;

            this.map.addLayer({
                "id": routelayername,
                "type": "line",
                "source": sourcename,
                "layout": {
                    "line-join": "round",
                    "line-cap": "round"
                },
                "paint": {
                    "line-color": routeColour,
                    "line-width": 6,
                },
                filter: ["!has", "point_count"],
            }, this.firstEventLayerName);

            this.ravens[ravenname].sources.push(sourcename);
            this.ravens[ravenname].layers.push(routelayername);

            startIndex = route.length - 2;
        }

        // Standard procedure of updating the "animated" route

        var geoJsonRoute = this.getGeoJsonLineForRoute(route, startIndex, -1);

        var carRouteSource;
        if(geoJsonRoute)
        {
            carRouteSource = {
                "type": "FeatureCollection",
                "features": [
                    {
                        "type": "Feature",
                        "geometry": {
                            "type": "LineString",
                            "coordinates": geoJsonRoute
                        },
                        "properties": {
                            "type": "route"
                        }
                    }
                ]
            };
        }
        else
        {
            carRouteSource = {
                "type": "FeatureCollection",
                "features": [ ]
            };
        }

        // checkGeoJSON(carRouteSource);
        if (this.ravens[ravenname].carRouteSource) {
            this.ravens[ravenname].carRouteSource.setData(carRouteSource);
        } else {
            // console.log("mapboxMap.updateCarAndAnimtedRouteSource this.ravens[ravenname].carRouteSource is undefined for: ", ravenname, this.ravens[ravenname]);
        }

        return startIndex;

    }

    ////////////////
    //MAP CONTROLS//
    ////////////////

    animateCameraToPoint(point, speed = 1000) {
        try {
            this.map.panTo(point, {
                duration: speed,
                easing: (t) => { return t } //linear easing
            });
        } catch (e) {
            console.error(e);
        }
    }

    zoomToExtents(bounds, now = false) {

        //don't zoom extents if passed a certain threshold which is similar to that of the default zoom level
        //this is a UX fix which prevents a zoom behavior which is too close to the cars
        if (bounds._ne.lng - bounds._sw.lng < 0.0122 && bounds._ne.lat - bounds._sw.lat < 0.0036) {
            if(now) {
                this.map.flyTo({
                    center: [bounds._ne.lng, bounds._sw.lat],
                    linear: true,
                    duration: 0,
                    padding: 20,
                });
            }
            else {
                this.map.flyTo({
                    center: [bounds._ne.lng, bounds._sw.lat],
                    padding: 20,
                    speed: 1.7
                });
            }

            return;
        }

        if (now) {
            this.map.fitBounds(bounds, {
                linear: true,
                duration: 0,
                padding: 20,
            });
        }
        else {
            this.map.fitBounds(bounds, {
                padding: 20,
                speed: 1.7
            });
        }
    }

    onDragStart = (e) => {

        if (this.mapboxControlIsFollowingSelectedRaven === true) {
            this.mapboxControlIsFollowingSelectedRaven = false;
            this.mapboxAddToggleFollowSelectedRavenControl();
        }

    }

    onRotate = (e) => {

        this.ravens.list.forEach((name) => {
            this.setHeading(name, this.ravens[name].heading);
        });

    }

    setHeading(name, heading) {

        try {
            if (heading !== 0) {
                this.ravens[name].heading = heading;
                this.ravens[name].carRouteSource._data.features[0].properties.heading = this.heading - this.map.getBearing();

                // checkGeoJSON(this.ravens[name].carRouteSource._data);

                this.ravens[name].carRouteSource.setData(this.ravens[name].carRouteSource._data);
            }
        } catch (e) {
            this.ravens[name].initialHeading = heading;
        }
    }


    /////////////
    //RENDERING//
    /////////////

    render() {

        return (
            <div className="mapbox-container">
                <ResizeThrottler interval={300} callback={this.resize} />
                <BackgroundRefresher ref={(bgrefresher) => { this.bgrefresher = bgrefresher; }} tripSharing={this.props.tripSharing} />
                <div id={this.props.mapId} className="mapbox-map mapboxgl-ctrl"></div>
            </div>
        );
    }

    addEventsLayer(ravenuuid, vehiclename, events) {

        var sourcename = ravenuuid + "-events";
        var layername = ravenuuid + "-events";

        var src = {
            "type": "geojson",
            "data": {
                "type": "FeatureCollection",
                "features": this.makeEventFeaturesList(ravenuuid, vehiclename, events)
            }
        };


        this.addSource(sourcename, src);
        this.map.addLayer({
            "id": layername,
            "type": "symbol",
            "source": sourcename,
            "layout": {
                "icon-size": 0.4,
                "icon-offset": [0, -30],
                "icon-allow-overlap": true,
                "icon-image": {
                    "type": "identity",
                    "property": "icon"
                },
            },
            "paint": {
                "icon-color": {
                    "type": "identity",
                    "property": "icon-color"
                },
                "icon-opacity": this.defaultEventOpacity
            },
            filter: ["!has", "point_count"],
        }, this.firstCarLayerName);

        if (!this.firstEventLayerName) {
            this.firstEventLayerName = layername;
        }

        this.ravens[ravenuuid].sources.push(sourcename);
        this.ravens[ravenuuid].layers.push(layername);

        return events.length;

    }

    updateEventsLayer(ravenname, vehiclename, events) {

        var sourcename = ravenname + "-events";

        var newData = {
            "type": "FeatureCollection",
            "features": this.makeEventFeaturesList(ravenname, vehiclename, events)
        };

        // checkGeoJSON(newData);

        this.map.getSource(sourcename).setData(newData);

    }

    makeEventFeaturesList(uuid, vehiclename, events) {

        var featuresList = [];
        var self = this;
        if(!events) return featuresList;

        events.forEach(function (elem, num) {
            var center = elem.geoStamp !== null ? [elem.geoStamp.lon, elem.geoStamp.lat] : null;
            var place_name = document.getEventName(elem) + ', ' + moment(RavenUtil.convertTs(elem.ts)).format('MMMM Do[,] h:mm a');
            if (center !== null && place_name !== null) {
                var iconcolor = self.warningColour;
                if (elem.type.indexOf('ENGINE') > -1 || elem.type.indexOf('UNPLUGGED') > -1) iconcolor = self.engineColour;
                if (elem.type.indexOf('SPEEDING') > -1) iconcolor = self.speedingColour;
                if (elem.type.indexOf('ENGINE_OFF') > -1 && num === 0) iconcolor = self.engineColour;
                // FIXME - how to handle last engine off
                // if (type.indexOf('engine off') > -1 && num === self.props.features.length - 1) iconname = "green-feature";

                var feature = {
                    "type": "Feature",
                    "properties": {
                        "uuid": uuid,
                        "vehicle_name": vehiclename,
                        "place_name": place_name,
                        "id": num,
                        "icon": "map-feature",
                        "icon-color": iconcolor
                    },
                    "geometry": {
                        "type": "Point",
                        "coordinates": [center[0], center[1]],
                    }
                };
                featuresList.push(feature);
            } else {
                // console.info("Feature with missing attributes which cannot be rendered to the map: ", elem, elem.center === null, elem.place_name === null, elem.id === null);
            }
        });

        return featuresList;
    }

    addSource(sourceName, geoJSON) {
        // checkGeoJSON(geoJSON.data);

        // console.log("Adding Source:",sourceName);

        this.map.addSource(sourceName, geoJSON);
    }

}


